import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TailwindColors } from '../../../common/constants/tailwind-colors';
import { BaseChartAbstract } from '../base-chart.class';
import {
  ChartCustomColor,
  ChartData,
  NormalizedChartData as GenericChartData,
} from '../models/chart.model';

@Component({
  selector: 'spog-gauge-chart',
  templateUrl: './spog-gauge-chart.component.html',
  styleUrls: ['./spog-gauge-chart.component.scss'],
  imports: [NgxChartsModule],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'block h-[150px]',
    '[style.--gauge-color]': 'getGaugeColor()',
  },
})
export class SpogGaugeChartComponent extends BaseChartAbstract {
  @Input() gaugeLabel = 'Default';

  valueFormatting = (value: number) => `${value}%`;

  protected override getCustomColors(): ChartCustomColor[] {
    if (this.customColors && this.customColors.length > 0) {
      return this.customColors;
    }
    return [{ name: this.gaugeLabel, value: TailwindColors.chartRed }];
  }

  protected override initializeChart(
    chartData: GenericChartData[]
  ): ChartData[] {
    return this.customColors.map(() => ({
      name: this.gaugeLabel,
      value: chartData[0].value || 0,
    }));
  }

  getGaugeColor() {
    return this.customColors[0]?.value || TailwindColors.chartRed;
  }
}
